/*
 * @Author: yangecheng
 * @Date: 2025-04-27 16:38:46
 * @Description: 
 */
import { Component } from 'react'
import { Tabs, ConfigProvider } from 'antd'
import './css/antd.css'
import App from './App'
import App2 from './App2'
import App3 from './App3'
import './css/tabs.css'

let { TabPane } = Tabs

// 主题颜色
ConfigProvider.config({
  theme: {
    primaryColor: '#717171ff',
    errorColor: '#830002ff',
    warningColor: '#946300ff',
    successColor: '#2c8500ff',
    infoColor: '#717171ff',
  },
});

class TabsPage extends Component {

    state = {
        tabsKey: '2'
    }

    handleChangeTabs = (tabsKey) => {
        this.setState({
            tabsKey
        })
    }

    render() {
        return (
            <Tabs style={{ marginLeft: '10px' }} size='large' defaultActiveKey={this.state.tabsKey} onChange={this.handleChangeTabs} animated='true' className='tabs'>
                <TabPane tab='常用功能' key='2'>
                    <App2 />
                </TabPane>
                <TabPane tab='文本对比' key='3'>
                    <App3 />
                </TabPane>
                <TabPane tab='工作区' key='1'>
                    <App />
                </TabPane>
            </Tabs>
        )
    }
}

export default TabsPage